import { render, staticRenderFns } from "./FeatureAiQuestionForm.vue?vue&type=template&id=7042b412"
import script from "./FeatureAiQuestionForm.vue?vue&type=script&lang=js"
export * from "./FeatureAiQuestionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports